export const sortASCII = (obj, isSort) => {
  let arr = [];
  Object.keys(obj).forEach(item => arr.push(item));
  let sortArr = isSort ? arr.sort() : arr.sort().reverse();
  let sortObj = {};
  for (let i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]];
  }
  return sortObj;
};
const formatNum = arg0 => {
  let str = arg0.toString();
  if (str.length == 1) {
    return "0" + str;
  } else {
    return str;
  }
};
export const formatTime = (timestamps, format) => {
  var date = new Date(timestamps);
  var finalstr = format;
  finalstr = finalstr.replace("yyyy", date.getFullYear());
  finalstr = finalstr.replace("MM", formatNum(date.getMonth() + 1));
  finalstr = finalstr.replace("dd", formatNum(date.getDate()));
  finalstr = finalstr.replace("hh", formatNum(date.getHours()));
  finalstr = finalstr.replace("mi", formatNum(date.getMinutes()));
  finalstr = finalstr.replace("ss", formatNum(date.getSeconds()));
  return finalstr;
};
class testKeys {
  static merchant_no = "6666XF20230306001";
  static msg_id = "666";
  static app_id = "10000000006666001";
  static api_gw_public_key =
    "YyQyCaWdilrUL3oFZ6oeS8ZvWxHuGkmFsTZvq3eKYLyMY3autqJK2ik7EzuMpaCRBJ5ojwB3Ffs9vSqhT67KxG3KbAiQgf12qNZDGYfVaAEtscbJXCcGvSDIWsbuZkmyH5NzlcsZsOR90HvGPZCD9OFcIYbksqfoDcLISB8kFaONi7TwYpofSuJLYGaJvDROyeG74kvJCriGBICGZE3MDVWej7pXaUtSnofre6GFJhUD673thInTvDLFiw7yS1GF";
  static aesKey = "5KF4efouyBWmx643Hps1uw==";
}
class prodKeys {
  static merchant_no = "6666XF20230306001";
  static msg_id = "666";
  static app_id = "10000000006666001";
  static api_gw_public_key =
    "YyQyCaWdilrUL3oFZ6oeS8ZvWxHuGkmFsTZvq3eKYLyMY3autqJK2ik7EzuMpaCRBJ5ojwB3Ffs9vSqhT67KxG3KbAiQgf12qNZDGYfVaAEtscbJXCcGvSDIWsbuZkmyH5NzlcsZsOR90HvGPZCD9OFcIYbksqfoDcLISB8kFaONi7TwYpofSuJLYGaJvDROyeG74kvJCriGBICGZE3MDVWej7pXaUtSnofre6GFJhUD673thInTvDLFiw7yS1GF";
  static aesKey = "5KF4efouyBWmx643Hps1uw==";
}
export const signKeys = process.env.VUE_APP_ENV == "test" ? testKeys : prodKeys;
